import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Box, Button, Container, Typography } from "@mui/material";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import GradientIcon from "../components/GradientIcon";
import HaveQuestions from "../components/HaveQuestions";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";

const gradientHoverSx = {
  position: "relative",
  border: "2px solid transparent",
  backgroundClip: "padding-box",
  transition: "all 0.3s ease",
  "&:hover::before": {
    opacity: 1,
  },
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "24px",
    padding: "2px",
    background: "linear-gradient(90deg, #FF7FAC, #5834BA)",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    opacity: 0,
    transition: "opacity 0.3s ease",
  },
};



const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Helmet>
        <title>DAM Journey - Terms of Use</title>
        <meta
          name="description"
          content="Terms of Use"
        />
        <meta
          property="keywords"
          content="DAM, DAM Journey, DAM Practice, DAM Consultant, DAM Consulting, DAM Practitioner, DAM Service, DAM Product, DAM Discovery, DAM Implementation, DAM Deployment, Terms of Use"
        />
      </Helmet>
      <Box>
        {/* Hero Banner Section */}
        <Box
            sx={{
              width: "100%",
              height: "168px",
              background: "linear-gradient(0deg, #2A2177 0%, #0624BE 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center", // ADD THIS
              textAlign: "center", // ADD THIS
              px: "24px", // optional cleaner spacing
              overflow: "hidden",
              position: "relative",
              "@media (max-width: 780px)": {
                flexDirection: "column",
                textAlign: "center",
                px: "16px",
                pt: "48px",
                pb: 2,
                height: "133px",
              },
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: "2.5rem",
                fontWeight: "Bold",
                color: "#ffffff",
                lineHeight: 1.3,
                mb: 2,
                "@media (max-width: 780px)": {
                  fontSize: "2rem",
                  fontWeight: "semiBold",
                  mb: 1,
                },
              }}
            >
              Terms of Use
            </Typography>
          </Box>

        {/* Description Section */}
        <Box
          sx={{
            py: {xs: "30px",
                   sm: "48px",
                   lg: "48px"},

            px:   {xs: "16px",
                   sm: "24px",
                   lg: "84px"}

          }}
        >
          <Box
                sx={{
                  flex: 1,
                  backgroundColor: "#ffffff",
                  borderRadius: "24px",
                  p: 4,
                  boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
                }}
              >
                {/* Header */}
                <Typography
                  sx={{
                   fontSize: "1.5rem",
                   fontWeight: 600,
                   "@media (max-width: 780px)": {
                      fontSize: "1.25rem",
                    },
                    color: "#2A2177",
                    mb: 1,
                  }}
                >
                  Terms and Conditions for Use of This Web Site
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1rem",
                    color: "#00000099",
                    mb: 3,
                  }}
                >
                  Your access to and use of this web site (the "Site") is conditioned on acceptance of
                  the terms of conditions set forth herein. Read these terms before using the Site.
                  By accessing, using, viewing, browsing the Site, you agree to these terms.
                  If you do not agree to these terms, do not access the Site in any way.
                </Typography>

                {/* Header */}
                <Typography
                  sx={{
                   fontSize: "1.5rem",
                   fontWeight: 600,
                   "@media (max-width: 780px)": {
                      fontSize: "1.25rem",
                    },
                    color: "#2A2177",
                    mb: 1,
                  }}
                >
                  Materials
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1rem",
                    color: "#00000099",
                    mb: 3,
                  }}
                >
                 The materials (including but not limited to the text, information, data, audio,
                 video and computer programs) (the "Materials") on this Site are provided by DAM Journey
                 LLC as a service to public and may be used for informational purposes only.
                </Typography>

                {/* Header */}
                <Typography
                  sx={{
                   fontSize: "1.5rem",
                   fontWeight: 600,
                   "@media (max-width: 780px)": {
                      fontSize: "1.25rem",
                    },
                    color: "#2A2177",
                    mb: 1,
                  }}
                >
                  Copyrights
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1rem",
                    color: "#00000099",
                    mb: 3,
                  }}
                >
                  Some of the Materials at the Site are copyrighted and any unauthorized use of any of the
                  Materials at the Site may violate copyright, trademark, and other laws.
                  You may not copy, reproduce, modify, republish, upload, post, transmit or
                  distribute the Materials in any way unless you obtain permission in writing from
                  DAM Journey LLC in advance.
                </Typography>


                {/* Header */}
                <Typography
                  sx={{
                   fontSize: "1.5rem",
                   fontWeight: 600,
                   "@media (max-width: 780px)": {
                      fontSize: "1.25rem",
                    },
                    color: "#2A2177",
                    mb: 1,
                  }}
                >
                  Updates to the Terms and Conditions Document
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1rem",
                    color: "#00000099",
                    mb: 3,
                  }}
                >
                  DAM Journey LLC may revise these terms and conditions for use at any time
                  by updating the "Terms and Conditions for Use of This Web Site" page.
                  You should visit this page from time to time to review the then current terms and
                  conditions for use, because they are binding on you. Certain provisions of these
                  terms and conditions may be superseded by expressly designated legal notices or terms
                  located on particular pages at the Site.
                </Typography>
            </Box>
          </Box>

        {/* Have Questions Section */}
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default Terms;
